//Removed after make refactor in jsProductAis
LUC.jsLegacyFaq = {
    init: function () {
        const $faqHeading = $(".faq-legacy-accordion dl > dt > button");
        $(".faq-legacy-accordion dl > dd").attr("aria-hidden", true);
        $(".faq-legacy-accordion dl > dd").each(function () {
            $(this).hide();
        });
        $faqHeading.attr("aria-expanded", false);
        $faqHeading.unbind("click").on("click", function (event) {
            event.preventDefault();
            if ($(this).parent().hasClass("active")) {
                $(this).parent().removeClass("active");
                $faqHeading.attr("aria-expanded", false);
                $(this)
                    .parent()
                    .parent()
                    .find("#" + $(this).attr("aria-controls"))
                    .attr("aria-hidden", true);
                $(".faq-legacy-accordion dl > dd").slideUp(200);
                return false;
            }
            let $this = $(this);
            $faqHeading.attr("aria-expanded", false);
            $this.attr("aria-expanded", true);
            $(this)
                .parent()
                .parent()
                .find("#" + $(this).attr("aria-controls"))
                .attr("aria-hidden", false);
            $(".faq-legacy-accordion dt").removeClass("active");
            $this.parent().addClass("active");
            $this.addClass("active").parent().siblings("dt").removeClass("active");
            $(".faq-legacy-accordion dl > dd").slideUp(200);
            $this.parent().next().slideDown(200).siblings("dd").slideUp(200);
        });
        $faqHeading.on("keydown", function (event) {
            let keyCode = event.keyCode || e.which;
            if (keyCode === 13) {
                $(this).trigger("activate");
            }
        });
    },
    unload: function () {
        $(".faq-legacy-accordion dl > dt > button").off("click activate");
        $(".faq-legacy-accordion dl > dt > button").off("keydown");
    },
};
